// import jsPDF from "jspdf";
const { jsPDF } = window.jspdf
import html2canvas from "html2canvas";

class PdfUtils {
    html2Pdf(doc, filename) {
        var shareContent = doc;
        var w = shareContent.offsetWidth; //获取dom 宽度
        var h = shareContent.offsetHeight; //获取dom 高度
        var canvas = document.createElement("canvas"); //创建一个canvas节点
        var scale = 1.5; //定义任意放大倍数 支持小数
        canvas.width = w * scale; //定义canvas 宽度 * 缩放
        canvas.height = h * scale; //定义canvas高度 *缩放
        canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
        var opts = {
            scale: scale, // 添加的scale 参数
            canvas: canvas, //自定义 canvas
            // logging: true, //日志开关，便于查看html2canvas的内部执行流程
            width: w, //dom 原始宽度
            height: h,
            useCORS: true // 【重要】开启跨域配置
        };
        html2canvas(shareContent, opts).then(canvas => {
            // 返回图片dataURL，参数：图片格式和清晰度(0-1)
            let pageData = canvas.toDataURL("image/jpeg", 1.0);

            //方向默认竖直，尺寸ponits，格式a4[595.28,841.89]
            let pdf = new jsPDF("", "pt", "a4");
            let margin = 50;
            let width = 595.28 - margin * 2;
            //addImage后两个参数控制添加图片的尺寸，此处将页面高度按照a4纸宽高比列进行压缩
            pdf.addImage(
                pageData,
                "JPEG",
                margin,
                margin,
                width,
                (width / canvas.width) * canvas.height
            );

            pdf.save(filename + ".pdf");
        });
    }

    imgs2Pdf(doc, filename) {
        var shareContent = doc;
        var w = shareContent.offsetWidth; //获取dom 宽度
        var h = shareContent.offsetHeight; //获取dom 高度
        var canvas = document.createElement("canvas"); //创建一个canvas节点
        var scale = 2; //定义任意放大倍数 支持小数
        canvas.width = w * scale; //定义canvas 宽度 * 缩放
        canvas.height = h * scale; //定义canvas高度 *缩放
        canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
        var opts = {
            scale: scale, // 添加的scale 参数
            canvas: canvas, //自定义 canvas
            logging: true, //日志开关，便于查看html2canvas的内部执行流程
            width: w, //dom 原始宽度
            height: h,
            useCORS: true // 【重要】开启跨域配置
        };
        console.log("====原始尺寸====");
        console.log(w + "  " + h);
        console.log("=========");
        console.log("====缩放完尺寸====");
        console.log(canvas.width + "  " + canvas.height);
        console.log("=========");
        html2canvas(shareContent, opts).then(canvas => {
            const context = canvas.getContext("2d");
            // 【重要】关闭抗锯齿 https://segmentfault.com/a/1190000011478657
            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

            console.log("====转换完尺寸====");
            console.log(canvas.width + "  " + canvas.height);
            console.log("=========");
            //未生成pdf的html页面高度
            var leftHeight = h;
            //页面偏移
            var position = 0;

            var pageData = canvas.toDataURL("image/jpeg", 1.0);
            console.log("====pageData.length====");
            console.log(pageData.length);
            console.log("=========");
            // var pdf = new jsPDF("", "pt", "a4");
            var pdf = new jsPDF({
                orientation: "",
                unit: "pt",
                format: [1131, 800]
            });

            //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
            while (leftHeight > 0) {
                console.log(
                    "  leftHeight=" + leftHeight + "  position=" + position
                );
                pdf.addImage(pageData, "JPEG", 0, position, w, h);
                leftHeight -= 1131;
                position -= 1131;
                //避免添加空白页
                if (leftHeight > 0) {
                    pdf.addPage();
                }
            }
            pdf.save(filename + ".pdf");
        });
    }

    imgs2Pdf2(doc, filename) {
        var w = doc.offsetWidth; //获取dom 宽度
        var h = doc.offsetHeight; //获取dom 高度
        var scale = 2; //定义任意放大倍数 支持小数
        var opts = {
            scale: scale, // 添加的scale 参数
            useCORS: true, // 【重要】开启跨域配置
        };
        console.log("====原始尺寸====");
        console.log(w + "  " + h);
        console.log("=========");
        html2canvas(doc, opts).then(canvas => {
            //未生成pdf的html页面高度
            var leftHeight = h;
            //页面偏移
            var position = 0;

            var pageData = canvas.toDataURL("image/jpeg", 1.0);
            console.log("====pageData.length====");
            console.log(pageData.length);
            console.log("=========");
            var pdf = new jsPDF({
                orientation: "",
                unit: "pt",
                format: [1131, 800]
            });

            //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
            while (leftHeight > 0) {
                console.log(
                    "  leftHeight=" + leftHeight + "  position=" + position
                );
                pdf.addImage(pageData, "JPEG", 0, position, w, h);
                leftHeight -= 1131;
                position -= 1131;
                //避免添加空白页
                if (leftHeight > 0) {
                    pdf.addPage();
                }
            }
            pdf.save(filename + ".pdf");
        });
    }
}

export const pdfUtils = new PdfUtils();
